// extracted by mini-css-extract-plugin
module.exports =  {"root":"CpdXITEtYN8R1xOxCEAz"};